/** EAA-1820: split out of `cells.tsx` (a plain helper + a type, not a
 *  component) so that file only exports components — react-refresh's
 *  `only-export-components` rule flags a `.tsx` mixing the two. */

export type CellTone = 'ok' | 'warn' | 'off';

export function initialsOf(text: string): string {
    const clean = text.replace(/[^a-zA-Z0-9]/g, ' ').trim();
    const parts = clean.split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}
